// Canonical design-token hexes. Must stay in sync with tailwind.config.js
// (theme.extend.colors). Use these in JS contexts that cannot consume
// Tailwind classes: charts, SVG attributes, canvas, inline styles.

export const COLORS = {
  // Brand
  primary: "#082746",
  secondary: "#38C6FF",
  secondaryDark: "#0B7BA8",
  success: "#34A853",
  danger: "#E51515",
  warning: "#F59E0B",

  // Semantic gray scale
  darkgrey: "#65646A",
  grey: "#85838F",
  mediumgrey: "#A6A6A7",
  lightgrey: "#F5F8F9",
  bggrey: "#E4E4E4",

  // Surfaces
  surface: "#F8FAFC",
  surfaceHover: "#EFF4FB",
  surfaceActive: "#E4E4E4",
  surfaceBorder: "#D0D5DD",
  surfaceDisabled: "#E8ECEF",

  // Chat
  chatUser: "#6581B9",
  chatAssistant: "#EFF4FB",
  chatMuted: "#767499",
};

// "#RRGGBB" + alpha -> "rgba(r, g, b, a)" for chart fills/grid lines.
export const hexToRgba = (hex, alpha) => {
  const num = parseInt(hex.replace("#", ""), 16);
  const r = (num >> 16) & 255;
  const g = (num >> 8) & 255;
  const b = num & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
